<template>
    <el-button type="info" size="small" v-bind="$attrs" v-on="$listeners"><jj-icons type="refreshLeft" />
        {{ $t('buttons.reset') }}
    </el-button>
</template>
<script>
export default {
    name: 'ButtonReset'
}
</script>
